var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 41,
    fill: "#50CD89",
    fillOpacity: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65.5,
    r: 54.5,
    fill: "#50CD89",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65.5,
    r: 65.5,
    fill: "#50CD89",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightGreen);
export default __webpack_public_path__ + "static/media/LightGreen.275416d75b0dedf6185dd15c62507307.svg";
export { ForwardRef as ReactComponent };